import { User } from "../models/Person";

export type BrowsePeopleRole = "all" | "mentors" | "mentees" | "guests";

/** Applies Browse People tab filters client-side after directory search. */
export function filterBrowsePeopleByRole(
  profiles: User[] | undefined | null,
  role: BrowsePeopleRole,
): User[] {
  if (!profiles?.length) {
    return [];
  }

  switch (role) {
    case "mentors":
      return profiles.filter((profile) => Boolean(profile.isMentor || profile.isAdmin));
    case "mentees":
      return profiles.filter(
        (profile) => !profile.isMentor && !profile.isAdmin && !profile.isGuest,
      );
    case "guests":
      return profiles.filter((profile) => Boolean(profile.isGuest));
    default:
      return profiles;
  }
}

/** Browse search results; NYC omits mentees from directory tabs and the All list. */
export function filterBrowsePeopleResults(
  profiles: User[] | undefined | null,
  role: BrowsePeopleRole,
  excludeMentees: boolean,
): User[] {
  if (excludeMentees && role === "mentees") {
    return [];
  }

  const filtered = filterBrowsePeopleByRole(profiles, role);

  if (!excludeMentees || role !== "all") {
    return filtered;
  }

  return filtered.filter(
    (profile) => Boolean(profile.isMentor || profile.isAdmin || profile.isGuest),
  );
}
